import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function CTASection({ title, body, primaryLabel = "Start a request", primaryTo = "/start" }) {
  return (
    <section className="relative py-20 md:py-28" data-testid="cta-section">
      <div className="max-w-5xl mx-auto px-5 lg:px-8">
        <div className="relative overflow-hidden rounded-3xl border border-[#272B36] bg-[#121419] p-8 sm:p-12 md:p-16">
          <div className="absolute inset-0 glow-tl pointer-events-none" />
          <div className="relative max-w-2xl">
            <p className="eyebrow">Start here</p>
            <h2 className="mt-3 font-display text-4xl sm:text-5xl text-[#F4F1EA] leading-[1.05]">{title}</h2>
            <p className="mt-4 text-slate-300 text-base sm:text-lg leading-relaxed">{body}</p>
            <div className="mt-8 flex flex-wrap gap-3">
              <Link
                to={primaryTo}
                data-testid="cta-section-primary"
                className="inline-flex items-center gap-2 bg-[#D9B36C] text-[#0B0C10] font-semibold px-7 py-3.5 rounded-full hover:bg-[#E5C688] transition-colors"
              >
                {primaryLabel} <ArrowRight size={16} />
              </Link>
              <Link
                to="/services"
                data-testid="cta-section-secondary"
                className="inline-flex items-center gap-2 border border-[#272B36] text-[#F4F1EA] font-medium px-7 py-3.5 rounded-full hover:bg-white/5 transition-colors"
              >
                See practice areas
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
